import { useCallback } from 'react';
import { useForm } from 'react-hook-form';

import { type AddressForm, defaultAddressForm } from '../../address.config';

// ─────────────────────────────────────────────────────────────────────────────

export const useAddressForm = (params: UseAddressFormParams) => {
  const { defaultValues, onSubmitSuccess } = params;

  // ─── Form ──────────────────────────────────────────────────────────────

  const form = useForm<AddressForm>({
    defaultValues: {
      ...defaultAddressForm,
      ...defaultValues,
    },
    mode: 'onChange',
  });

  // ─── Submit ────────────────────────────────────────────────────────────

  const submitForm = useCallback(
    (formData: AddressForm) => {
      onSubmitSuccess(formData);
    },
    [onSubmitSuccess],
  );

  // ─────────────────────────────────────────────────────────────────────────

  return {
    form,
    submitForm,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseAddressFormParams = Readonly<{
  defaultValues?: Partial<AddressForm>;
  onSubmitSuccess: (formData: AddressForm) => void;
}>;
